import React, { useMemo } from 'react';
import { Input } from '@Sage/hoi-poi-ui';

function Number({ onBlur, ...props }) {
    const overrides = useMemo(
        () => ({
            input: {
                step: 'any',
                onKeyPress: (e) => {
                    e = e || window.event;
                    const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
                    const charStr = String.fromCharCode(charCode);
                    if (!charStr.match(/^[0-9.]+$/)) return e.preventDefault();
                },
                onBlur: (e) => {
                    const value = e.target?.value ? parseFloat(e.target.value, 10) : null;
                    onBlur && onBlur({ ...e, target: { ...e.target, value } });
                },
            },
        }),
        [onBlur],
    );

    return (
        <Input
            labelMode="horizontal"
            type="number"
            placeholder="0.00"
            overrides={overrides}
            {...props}
        />
    );
}

export default Number;
